<h2 mat-dialog-title>Cleanup configuration</h2>
<div mat-dialog-content>
    <p>New configuration will be effective after 1 week</p>

    <form #form="ngForm">
        <h2>Expiration delays</h2>
        <p>Number of days after which projects will be deleted</p>
        <p class="text-italic">From 30 to 3650 days (empty for no expiration on the module)</p>

        <mat-form-field>
            <mat-label>Photobook</mat-label>
            <input
                matInput
                min="30"
                max="3650"
                type="number"
                name="photobookCleanupDelayInDays"
                [(ngModel)]="result.photobookCleanupDelayInDays"
                (keydown.enter)="editSubscription()"
            />
        </mat-form-field>

        <mat-form-field>
            <mat-label>Gifting</mat-label>
            <input
                matInput
                min="30"
                max="3650"
                type="number"
                name="giftingCleanupDelayInDays"
                [(ngModel)]="result.giftingCleanupDelayInDays"
                (keydown.enter)="editSubscription()"
            />
        </mat-form-field>

        <mat-form-field>
            <mat-label>Print</mat-label>
            <input
                matInput
                min="30"
                max="3650"
                type="number"
                name="printCleanupDelayInDays"
                [(ngModel)]="result.printCleanupDelayInDays"
                (keydown.enter)="editSubscription()"
            />
        </mat-form-field>

        <h2>Notification delays</h2>
        <p>Number of days before expiration when a notification will be sent</p>
        <p class="text-italic">From 1 to 3650 days (empty for no notification on the module)</p>

        <mat-form-field>
            <mat-label>Photobook</mat-label>
            <input
                matInput
                min="1"
                type="number"
                name="photobookNotificationDelayInDays"
                #photobookNotificationDelay="ngModel"
                [(ngModel)]="result.photobookNotificationDelayInDays"
                (keydown.enter)="editSubscription()"
            />

            @if (photobookNotificationDelay.control.errors?.valueNotNull) {
                <mat-error>Should not be set if no cleanup config exist on the module</mat-error>
            }
            @if (photobookNotificationDelay.control.errors?.valueInvalid) {
                <mat-error>This value cannot be higher than the value configured on the module</mat-error>
            }
        </mat-form-field>

        <mat-form-field>
            <mat-label>Gifting</mat-label>
            <input
                matInput
                min="1"
                type="number"
                name="giftingNotificationDelayInDays"
                #giftingNotificationDelay="ngModel"
                [(ngModel)]="result.giftingNotificationDelayInDays"
                (keydown.enter)="editSubscription()"
            />
            @if (giftingNotificationDelay.control.errors?.valueNotNull) {
                <mat-error>Should not be set if no cleanup config exist on the module</mat-error>
            }
            @if (giftingNotificationDelay.control.errors?.valueInvalid) {
                <mat-error>This value cannot be higher than the value configured on the module</mat-error>
            }
        </mat-form-field>

        <mat-form-field>
            <mat-label>Print</mat-label>
            <input
                matInput
                min="1"
                type="number"
                name="printNotificationDelayInDays"
                #printNotificationDelay="ngModel"
                [(ngModel)]="result.printNotificationDelayInDays"
                (keydown.enter)="editSubscription()"
            />
            @if (printNotificationDelay.control.errors?.valueNotNull) {
                <mat-error>Should not be set if no cleanup config exist on the module</mat-error>
            }
            @if (printNotificationDelay.control.errors?.valueInvalid) {
                <mat-error>This value cannot be higher than the value configured on the module</mat-error>
            }
        </mat-form-field>
    </form>


</div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="editSubscription()">Ok</button>
</mat-dialog-actions>
